/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetMetaModel {
    getFixupPrototypeFunction() { return BudgetMetaModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetMetaModel>): BudgetMetaModel {
        let obj = Object.assign(new BudgetMetaModel(), model);
        BudgetMetaModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetMetaModel>): BudgetMetaModel {
        if (!model) return null;
        return BudgetMetaModel.newInstance(<BudgetMetaModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetMetaModel) {
        if (!obj) return;

        models.BudgetMetaModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetMetaModel): boolean {
        Object.setPrototypeOf(obj, BudgetMetaModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tracking) {
            models.BudgetTrackingModel.fixupPrototype(this.tracking);
        }
    }

    /**
     * tracking details
     */
    tracking: models.BudgetTrackingModel;

}
